import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookingResponse } from "../../../types/bookingTypes";
import { EMPTY_PAGE_INFO, mergePage, Page, PageInfo, pageInfoOf } from "../../../utils/pagination";

interface BookingState {
  bookings: BookingResponse[];
  pageInfo: PageInfo;
  loading: boolean;
  error: string | null;
}

const initialState: BookingState = {
  bookings: [],
  pageInfo: EMPTY_PAGE_INFO,
  loading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    endLoading(state) {
      state.loading = false;
    },
    setBookingsPage(state, action: PayloadAction<Page<BookingResponse>>) {
      state.bookings = mergePage(state.bookings, action.payload);
      state.pageInfo = pageInfoOf(action.payload);
      state.loading = false;
    },
    upsertBooking(state, action: PayloadAction<BookingResponse>) {
      const index = state.bookings.findIndex((b) => b.id === action.payload.id);
      if (index >= 0) {
        state.bookings[index] = action.payload;
      } else {
        state.bookings.unshift(action.payload);
      }
      state.loading = false;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const bookingActions = bookingSlice.actions;
export default bookingSlice;
